'use strict';

/**
 *
 * @name: sortDropdown
 *
 */

import DirectiveTemplate from './nn-base-select.directive.html';
import './nn-base-select.directive.scss';

function BaseSelectDirective() {

  'ngInject';

  return {
    restrict: 'E',
    replace: true,
    template: DirectiveTemplate,
    scope: {
      fields: '&',
      sortBy: '=',
      queryActive: '=*',
      hidePrefix: '=*',
      theme: '=*',
      descText: '@',
      cnSuffix: '=*',
    },
    link: function(scope) {


      /*
       *
       * @CONFIG
       *
       */

      scope.sortingFields = scope.fields();
      scope.isOpened = false

      /*
       *
       * @PUBLIC
       *
       */


      scope.onItemClick = function(item) {
        scope.sortBy = item;
      };

      scope.changeVisibility = (val = 'toggle') => {
        scope.isOpened = val === 'toggle' ? !scope.isOpened : val
      }


      /*
       *
       * @PRIVATE
       *
       */



      /*
       *
       * @INIT
       *
       */


      if (scope.queryActive && scope.sortBy.exclude) {
        scope.$watch('queryActive', function(newVal) {

          if (newVal && scope.sortBy.exclude.indexOf(newVal) > -1) {
            scope.sortBy = scope.sortingFields[0];
          }
        });
      }
    }
  };
}

export default BaseSelectDirective;



// WEBPACK FOOTER //
// ./app/components/nn-base-components/nn-base-select/nn-base-select.directive.js